import { render, staticRenderFns } from "./hrd-course-detail.vue?vue&type=template&id=69dba7ca&scoped=true"
import script from "./hrd-course-detail.vue?vue&type=script&lang=js"
export * from "./hrd-course-detail.vue?vue&type=script&lang=js"
import style0 from "./hrd-course-detail.vue?vue&type=style&index=0&id=69dba7ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dba7ca",
  null
  
)

export default component.exports